import React, { useState } from 'react';
import BlockUi from 'react-block-ui';
import CardContainer from './card-container';
import LabelCategory from '../label/label-category';
import CardBasic from './card-basic';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import env from '../../environment';
import transformWord from '../../utils/transformWord';

const CardProductor = ({
  blocking,
  cuenta,
  fotoURL = null,
  parcelas,
  hectareas,
  plantas,
  dataParcelas = [],
  etiquetas = {},
  producto = 1,
  especies = null,
  blockingEspecies = false,
}) => {
  const [fotoOpen, setFotoOpen] = useState(false);
  return (
    <>
      <div className="row pb-4">
        <div className="col-lg-6  mt-2">
          <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
            <CardContainer style={{ padding: '15px 20px' }}>
              <div className="row">
                <div className="col-lg-5 col-sm-3 text-center">
                  {fotoURL ? (
                    <button type="button" className="btn" style={{ borderRadius: '20px' }} onClick={() => setFotoOpen(!fotoOpen)}>
                      <img src={`${env.apiURL}/${fotoURL}`} className="profile_productor"></img>
                    </button>
                  ) : (
                    <img src={env.images.profile.productor} />
                  )}
                </div>
                <div className="col-lg-5 col-sm-7">
                  <div className="row" style={{ paddingTop: 16 }}>
                    <div className="col-sl-8">
                      <h6 className="font-lato-normal-400">Productor:</h6>
                      <h3 className="font-lato-normal-500 pb-3">{cuenta.nombre || '-'}</h3>
                      <LabelCategory label={cuenta.cuenta_categoria} color={cuenta.cuenta_categoria_color}></LabelCategory>
                    </div>
                    <div className="col-sl-4">
                      {(cuenta.clave_tx, cuenta.codigo_tx) ? (
                        <>
                          <h6 className="font-lato-normal-400">{cuenta.clave_tx}</h6>
                          <h3 className="font-lato-normal-400 pb-4">{cuenta.codigo_tx}</h3>
                        </>
                      ) : (
                        <>
                          <h6 className="font-lato-normal-400">-</h6>
                          <h3 className="font-lato-normal-400 pb-4">{cuenta.clave_tx || cuenta.codigo_tx || '-'}</h3>
                        </>
                      )}
                      {cuenta._fecha_ingreso != null && <h6 className="font-lato-normal-400">Desde {cuenta._fecha_ingreso}</h6>}
                    </div>
                  </div>
                </div>
                <div className="col-lg-2 col-sm-2">
                  <div className="row">
                    {cuenta.certifications?.map(cert => {
                      return (
                        <div key={cert.id} className="col-4 col-sm-12 col-md-12 col-lg-12">
                          <img
                            src={`${env.assetURL}${cert.url}`}
                            alt={cert.name}
                            style={{
                              width: '45px',
                              marginBottom: '15px',
                            }}></img>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </CardContainer>
          </BlockUi>
        </div>
        <div className="col-lg-6 mt-2">
          <div className="row">
            <div className="col-lg col-sm-4 mt-2">
              <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
                <CardBasic
                  // height={topHeight}
                  style={{ padding: '10px 5px' }}
                  height={110}
                  label={transformWord(etiquetas?.parcela, ['plural', 'capitalize'])}
                  value={parcelas}></CardBasic>
              </BlockUi>
            </div>
            {/* {producto === env.productos.CAFE && ( */}
              <div className="col-lg col-sm-4 mt-2">
                <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
                  <CardBasic
                    // height={topHeight}
                    style={{ padding: '10px 5px' }}
                    height={110}
                    label="Hectáreas"
                    value={hectareas}></CardBasic>
                </BlockUi>
              </div>
            {/* )} */}
            <div className="col-lg col-sm-4 mt-2">
              <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
                <CardBasic
                  // height={topHeight}
                  style={{ padding: '10px 7px' }}
                  height={110}
                  label={transformWord(etiquetas?.planta, ['plural', 'capitalize'])}
                  value={plantas}></CardBasic>
              </BlockUi>
            </div>
            {producto === env.productos.MIEL && (
              <>
                <div className="col-lg col-sm-4 mt-2">
                  <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
                    <CardBasic
                      // height={topHeight}
                      style={{ padding: '10px 5px' }}
                      height={110}
                      label="Kgs. de cosecha estimados"
                      value={dataParcelas
                        .reduce(
                          (acc, p) =>
                            !p.baja_parcela && !isNaN(parseFloat(p.estimacion_cosecha)) ? acc + parseFloat(p.estimacion_cosecha) : acc,
                          0
                        )
                        .toLocaleString('en-US', {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}></CardBasic>
                  </BlockUi>
                </div>
                {especies && (
                  <div className="col-lg-12 mt-2">
                    <BlockUi tag="div" message="" blocking={blockingEspecies} renderChildren={true}>
                      <CardContainer
                        style={{ padding: '15px 7px' }}
                        height={110}
                      >
                        <div className="px-3 py-2">
                          <h6 className="font-lato-normal-400 m-b-1" style={{ color: '#789D16' }}>
                            {'ESPECIES: '} 
                          </h6>
                          <p className="m-b-0" style={{ fontSize: '0.85rem', marginTop: '5px' }}>
                            {especies}
                          </p>
                        </div>
                      </CardContainer>
                    </BlockUi>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {fotoURL ? (
        <Modal isOpen={fotoOpen} toggle={() => setFotoOpen(!fotoOpen)} centered={true} size={'lg'}>
          <ModalBody>
            <img src={`${env.apiURL}/${fotoURL}`} style={{ width: '100%' }}></img>
          </ModalBody>
          <ModalFooter>
            <button type="button" className="btn btn-white" onClick={() => setFotoOpen(!fotoOpen)}>
              Cerrar
            </button>
          </ModalFooter>
        </Modal>
      ) : null}
    </>
  );
};

export default CardProductor;
